import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

/**
 * Persistent, low-profile banner shown while the device is offline.
 *
 * Sits above the bottom mobile nav (via `bottom: safe-area + 4rem`) so it
 * never overlaps system UI or the tab bar. Uses semantic warning tokens
 * to match the rest of the design system.
 *
 * Read-only flows continue to work from cache; destructive MDM operations
 * (Lock, Unlock, Unenroll, etc.) should be disabled by their owning
 * components — there is intentionally no offline mutation queue.
 */
export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-2 z-[55] flex items-center gap-2 rounded-lg border border-warning-border bg-warning-muted px-3 py-2 text-sm text-warning-muted-foreground shadow-md md:inset-x-auto md:left-4 md:right-auto md:max-w-sm"
      style={{
        bottom: `calc(env(safe-area-inset-bottom) + 4rem)`,
      }}
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span className="flex-1">
        You're offline. Viewing cached data — actions are disabled until you reconnect.
      </span>
    </div>
  );
}

export default OfflineBanner;
